var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatTableDataSource, MatDialog, MatDialogConfig } from '@angular/material';
import { MatSidenav } from '@angular/material/sidenav';
import { forkJoin, Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import * as moment from 'moment';
import { TranslateService } from '../../../../../../services/translate.service';
import { UserService } from '../../../../../../services/user.service';
import { WksApisService } from '../../../../services/wks-apis.service';
import { FormBuilder } from '@angular/forms';
import { CommonMethods } from '../../../../../common/tools/commonMethods';
import { GridTools } from '../../../../../common/tools/gridTools';
import { ModalCommonComponent } from '../../../../../common/components/modal-common/modal-common.component';
import { WksCentralService } from '../../../../services/wks-central.service';
import { RessourcesService } from '../../../../../../job/common/services/ressources.service';
import { ParamPartsSupplies_sch } from '../../../../models/wks-param.model';
import { environment } from '../../../../../../../environments/environment';
import { ToolArgs, ToolApiResponse, ProductStock } from '../../../../../../models/common.model';
export class PartsSuppliesTableComponent {
    constructor(_userService, _currentRoute, _translate, _wksCentralService, _ressourcesService, _dialog, _apiService, fb) {
        this._userService = _userService;
        this._currentRoute = _currentRoute;
        this._translate = _translate;
        this._wksCentralService = _wksCentralService;
        this._ressourcesService = _ressourcesService;
        this._dialog = _dialog;
        this._apiService = _apiService;
        this.fb = fb;
        this.dataSource = new MatTableDataSource();
        this.onDestroy = new Subject();
        this.dataColumnsDef = ParamPartsSupplies_sch;
        // private loadingSubject = new BehaviorSubject<boolean>(false);
        // loading$ = this.loadingSubject.asObservable();
        // loadingIndicator: boolean;
        this.cacheDatatemp = [];
        this.doUpdateDoc = [];
        this.reorderable = true;
        this.selected = [];
        this.pageSize = 12;
        this.editing = {};
        this.rows = [];
        this.lastEventTime = 0;
        this.SCAN_THRESHOLD = 20; // ms max entre 2 touches (scanner rapide)
        this._translate.onLangChanged.subscribe(() => {
            this.translateLabelsColumns();
        });
    }
    ngOnInit() {
        if (this._userService.getUserLogged() === undefined) {
            return;
        }
        this._currentRoute.paramMap.subscribe(params => {
            this.displayType = params.get('display');
        });
        if (this.displayType === null) {
            this.displayType = 'list';
        }
        const labelItem = this._currentRoute.snapshot.data[0]['itemOption'];
        this.sidenavCollapsed = true;
        this.hasBackdrop = true;
        this.initAllBooleans();
        this.initAllSubscribe();
        this.settingFormats();
        this.initParams();
        this.optionItem = labelItem;
        this.loadBrands();
        /*
        this.loadBrands()
        .then (brandList => {
    
          this.OKtoDisplaySelect = true;
        })
        .catch(error  => {
          console.log(JSON.stringify(error));
        });
    */
    }
    initAllBooleans() {
        this.OKtoDisplaySelect = false;
        this.OKtoDisplayList = false;
        this.okToSearch = false;
        this.doUpdateLinkBarcodeRef = false;
        this.loadingIndicator = false;
        this.scanCodeActivate = false;
        this.stockInProgress = false;
    }
    initParams() {
        this.selection = {
            paramType: '',
            brandName: '',
            brandRef: '',
            textSearch: '',
            barcode: ''
        };
        const listItem = this._wksCentralService.getTypesPartsSupplies();
        this.paramTypeList = [];
        for (const item of listItem) {
            const itemCur = {
                label: this._translate.getTranslate(item),
                value: item,
            };
            this.paramTypeList.push(itemCur);
        }
        const wksEntity = this._wksCentralService.getWksEntityCur();
        const entityOptions = JSON.parse(wksEntity.entityOptions);
        this.scanCodeActivate = entityOptions.scanCodeActivation;
    }
    settingFormats() {
        if (!this._wksCentralService.getWksEntityCur()) {
            return;
        }
        const otherDataString = this._wksCentralService.getWksEntityCur().otherData;
        const otherDataJson = JSON.parse(otherDataString);
        const intFormat = otherDataJson.internationnalFormat;
        this.timeFormat = this._ressourcesService.getFormat(intFormat, 'datetime', 'timeFormat');
        this.timeFormat = this.timeFormat.replace('dd', 'DD');
        this.timeFormat = this.timeFormat.replace('yyyy', 'YYYY');
        /*
        this.numberFormat = {
          locale: this._ressourcesService.getFormat(this.intFormat, 'numbers', 'locale'),
          minDecimal: Number.parseInt(this._ressourcesService.getFormat(this.intFormat, 'numbers', 'minimumFractionDigits'), 10),
          maxDecimal: Number.parseInt(this._ressourcesService.getFormat(this.intFormat, 'numbers', 'maximumFractionDigits'), 10),
          currency:  this._ressourcesService.getFormat(this.intFormat, 'numbers', 'currency'),
        };
        */
    }
    initAllSubscribe() {
        this._wksCentralService.onRegisterValid
            .pipe(takeUntil(this.onDestroy))
            .subscribe((event) => {
            if (event === 'cancelRegister') {
                this.toggleSidenav('');
            }
            if (event === 'closeRegisterAction') {
                this.toggleSidenav('');
                this.getParamPartsSuppliesSelect();
            }
            if (event === 'cancelUpload') {
                this.toggleSidenav('');
            }
            if (event === 'cancelUpdateLinkBarcodeRef') {
                this.toggleSidenav('');
            }
            if (event === 'cancelDisplayStockMovements') {
                this.doDisplayStockMovements = false;
                this.toggleSidenav('');
            }
            if (event === 'cancelUpdate') {
                this.toggleSidenav('');
            }
            if (event === 'closeUpdate') {
                this.toggleSidenav('');
                this.getParamPartsSuppliesSelect();
            }
            if (event === 'closeUpload') {
                this.toggleSidenav('');
                this.getParamPartsSuppliesSelect();
            }
            if (event === 'deleteParamSupplies') {
                this.getParamPartsSuppliesSelect();
            }
        });
        this.addListenerScan();
    }
    addListenerScan() {
        window.addEventListener('keydown', (event) => {
            if (event.key === undefined) {
                return;
            }
            const target = event.target;
            // Les autres champs de saisie doivent fonctionner normalement.
            // Le champ barcode reste autorisé.
            if (target.tagName === 'INPUT' &&
                target.id !== 'barcode') {
                return;
            }
            if (target.tagName === 'TEXTAREA' ||
                target.tagName === 'SELECT' ||
                target.isContentEditable) {
                return;
            }
            const now = Date.now();
            // Si trop lent → reset (probablement humain)
            if (now - this.lastEventTime > this.SCAN_THRESHOLD) {
                this.selection.barcode = '';
            }
            // ecoute windows renvoie le clavier ver le champ en focus.
            // pour eviter les interférence avec les champs de saisie manuelle.
            const isFast = now - this.lastEventTime <= this.SCAN_THRESHOLD;
            if (isFast) {
                event.preventDefault();
            }
            this.lastEventTime = now;
            // Ignore certaines touches
            if (event.key.length === 1) {
                this.selection.barcode += event.key;
            }
            // Reset du timer de fin de scan
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                if (this.selection.barcode.length > 3) { // seuil minimal
                    console.log('Code scanné:', this.selection.barcode);
                    this.getParamPartsSuppliesBarcode();
                }
                this.selection.barcode = '';
            }, 100); // fin de rafale
        });
    }
    loadBrands() {
        if (this._userService.getUserLogged() === undefined) {
            return;
        }
        this.brandFilteredList = [];
        let brandList;
        return new Promise((resolve, reject) => {
            this._wksCentralService.getWksBrandsList(this._userService.getUserLogged().entity)
                .pipe(takeUntil(this.onDestroy))
                .subscribe(data => {
                brandList = data.body;
                this.brandFilteredList = [...brandList];
                this.brandFilteredList.sort((obj1, obj2) => {
                    return obj1.brandName > obj2.brandName ? 1 : -1;
                });
                const emptyBrand = {
                    id: undefined,
                    stdEntity: this._userService.getUserLogged().entity,
                    brandRow: '',
                    brandName: '               ',
                    equipType: undefined,
                    modelName: undefined,
                    stdCreation: undefined,
                    stdLastupdate: undefined,
                    stdDisable: undefined,
                };
                // this.brandFilteredList.splice(0, 0,  emptyBrand);
                // unshift
                this.brandFilteredList.unshift(emptyBrand);
                this.OKtoDisplaySelect = true;
                resolve(brandList);
            }, err => {
                // console.log(err);
                if (err.status === 404) {
                }
                console.log(JSON.stringify(err));
                reject(err.status);
            });
        });
    }
    buildList() {
        this.displayedColumns = [
            { field: 'paramTypeLabel', headerName: this._translate.instant('paramTypeLabel'), sortable: true, filter: true, resizable: true, width: 100 },
            { field: 'brandName', headerName: this._translate.instant('brandName'), sortable: true, filter: true, resizable: true, width: 200 },
            { field: 'brandRef', headerName: this._translate.instant('brandRef'), sortable: true, filter: true, resizable: true, width: 150 },
            { field: 'oldRef', headerName: this._translate.instant('oldRef'), sortable: true, filter: true, resizable: true, width: 150 },
            { field: 'newRef', headerName: this._translate.instant('newRef'), sortable: true, filter: true, resizable: true, width: 150 },
            { field: 'partsSuppliesLabel', headerName: this._translate.instant('partsSuppliesLabel'), sortable: true, filter: true, resizable: true, width: 400 },
            { field: 'paramQty', headerName: this._translate.instant('paramQty'), sortable: false, filter: false, resizable: true, width: 100 },
            /*{ field: 'stdCreation', headerName: this._translate.instant('stdCreation'), type: 'DateFormat',
                cellRendererParams: { array: [this.timeFormat]},
                sortable: true, filter: true, resizable: true },*/
            { field: 'paramMaj', headerName: this._translate.instant('stdLastupdate'), type: 'TimeFormat',
                cellRendererParams: { array: [this.timeFormat] },
                sortable: true, filter: true, resizable: true, width: 150 },
            /*{ field: 'stdDisable', headerName: this._translate.instant('stdDisable'), type: 'DateFormat',
                cellRendererParams: { array: [this.timeFormat]},
                sortable: true, filter: true, resizable: true },*/
            { field: '', headerName: this._translate.instant('Action'),
                template: this.getActions(), width: 200
            },
        ];
        this.gridOptions = {
            columnDefs: this.getColDef(),
            enableFilter: true,
            rowDeselection: true,
            enableColResize: true,
            rowSelection: 'single',
            // navigateToNextCell: this.arrowNavigation, : non operationnel
            columnTypes: {
                'DateFormat': { cellRenderer: GridTools.dateRenderer_unixM },
                'TimeFormat': { cellRenderer: GridTools.dateRenderer_unixM },
            },
        };
        this.gridOptions.getRowStyle = function (params) {
            const data = params.data;
            if ((!data) || (data === 'undefined')) {
                return;
            }
            if (data.requestDefault) {
                // https://www.rapidtables.com/web/color/green-color.html
                return { background: '#9ACD32' };
            }
        };
        this.defaultColDef = {
            sortable: true,
            resizable: true,
            filter: true
        };
        this.autoGroupColumnDef = {
            filterValueGetter: function (params) {
                const colGettingGrouped = params.colDef.showRowGroup;
                const valueForOtherCol = params.api.getValue(colGettingGrouped, params.node);
                return valueForOtherCol;
            }
        };
        // this.loadingSubject.next(true);
        // this.getParamPartsSuppliesList();
        if (this._userService.getUserLogged() !== undefined) {
            this.userLangCur = this._userService.getUserLogged().userlang;
        }
        this.localeText = this._translate.getAgGridLabels();
    }
    onFilterTextBoxChanged(event) {
        /*
        const input = document.getElementById('nom') as HTMLInputElement;
        const valueFilter = input.value;
    */
        const valueFilter = event;
        this.gridApi.setQuickFilter(valueFilter);
    }
    refresh() {
        // this.getParamWorksRatesList();
        this.getParamPartsSuppliesSelect();
    }
    getColDef() {
        return this.displayedColumns;
    }
    getActions() {
        let actions;
        actions = '<button type="button" class="btn btn-default mat-icon-button " data-action-type="edit" data-toggle="tooltip" data-placement="left" title="' +
            this._translate.instant('edit tooltip') + '" style=" margin-left: 5px;margin-right: 5px;" >' +
            '<span data-action-type="edit" class="fa fa-edit" style="font-size: 20px"></span></button>' +
            '<button type="button" class="btn btn-default mat-icon-button" data-action-type="trash"  data-toggle="tooltip" data-placement="left" title="' +
            this._translate.instant('trash tooltip') + '" style="margin-left: 5px;margin-right: 5px;" >' +
            '<span data-action-type="trash" class="fa fa-trash" style="font-size: 20px"></span></button>';
        return actions;
    }
    getParamPartsSuppliesSelect() {
        this.OKtoDisplayList = false;
        this.selected = [];
        this.loadingIndicator = true;
        // if (this._userService.getUserLogged() === undefined ) { return; }
        this.dataSource.data = [];
        this._wksCentralService.getParamPartsSupplieSelect(this._userService.getUserLogged().entity, this.selection.paramType, this.selection.brandName, this.selection.brandRef, this._userService.getUserLogged().userlang).pipe(takeUntil(this.onDestroy), map(response => {
            this.buildList();
            const data = this.translateLabelsData(response.body);
            this.cacheDatatemp = [...data];
            this.extractColumnsName(data);
            this.affectData(data);
            return data;
        })).subscribe(data => {
            this.dataSource.data = data;
            this.loadingIndicator = false;
            this.OKtoDisplayList = true;
        }, err => {
            console.log(err);
            this.loadingIndicator = false;
            if ((err.status === 500) || (err.status === 404)) {
                const titleBox = this._translate.getTranslate('searching part & supplie');
                const messageBox = this._translate.getTranslate('no part or supplie found');
                this.displayMessageBox(titleBox, messageBox, 'ERROR', 'alertWks', '', null);
            }
        });
    }
    searchBybarCode() {
    }
    getParamPartsSupplieSearch() {
        this.selected = [];
        this.loadingIndicator = true;
        this.OKtoDisplayList = false;
        if (this._userService.getUserLogged() === undefined) {
            return;
        }
        this.dataSource.data = [];
        this._wksCentralService.getParamPartsSupplieSearch(this._userService.getUserLogged().entity, this.selection.paramType, this.selection.textSearch, this._userService.getUserLogged().userlang).pipe(takeUntil(this.onDestroy), map(response => {
            this.buildList();
            const data = this.translateLabelsData(response.body);
            this.cacheDatatemp = [...data];
            this.extractColumnsName(data);
            this.affectData(data);
            return data;
        })).subscribe(data => {
            this.dataSource.data = data;
            this.loadingIndicator = false;
            this.OKtoDisplayList = true;
        }, err => {
            this.loadingIndicator = false;
            console.log(err);
            if ((err.status === 500) || (err.status === 404)) {
                const titleBox = this._translate.getTranslate('searching part & supplie');
                const messageBox = this._translate.getTranslate('no part or supplie found');
                this.displayMessageBox(titleBox, messageBox, 'ERROR', 'alertWks', '', null);
            }
        });
    }
    getParamPartsSuppliesBarcode() {
        this.selected = [];
        this.loadingIndicator = true;
        this.OKtoDisplayList = false;
        if (this._userService.getUserLogged() === undefined) {
            return;
        }
        this.dataSource.data = [];
        this._wksCentralService.getParamPartSupplieList(this._userService.getUserLogged().entity, '', '', this._userService.getUserLogged().userlang, this.selection.barcode, true).pipe(takeUntil(this.onDestroy), map(response => {
            this.buildList();
            const data = this.translateLabelsData(response.body);
            this.cacheDatatemp = [...data];
            this.extractColumnsName(data);
            this.affectData(data);
            return data;
        })).subscribe(data => {
            this.dataSource.data = data;
            this.loadingIndicator = false;
            this.OKtoDisplayList = true;
        }, err => {
            this.loadingIndicator = false;
            console.log(err);
            if ((err.status === 500) || (err.status === 404)) {
                const titleBox = this._translate.getTranslate('searching part & supplie');
                const messageBox = this._translate.getTranslate('no part or supplie found');
                this.displayMessageBox(titleBox, messageBox, 'ERROR', 'alertWks', '', null);
            }
        });
    }
    changeSelection(orig, value) {
        switch (orig) {
            case 'paramType':
                this.selection.paramType = value.trim();
                this.verifOKtoSearch();
                break;
            case 'brandName':
                this.selection.brandName = value.trim();
                this.verifOKtoSearch();
                break;
            case 'brandRef':
                this.selection.brandRef = value;
                this.verifOKtoSearch();
                break;
        }
    }
    clearBrandRef() {
        this.selection.brandRef = '';
        this.verifOKtoSearch();
    }
    changeSearch(value) {
        this.selection.textSearch = value.trim();
        if (this.selection.textSearch.length < 3) {
            return;
        }
        if (this.selection.paramType === undefined || this.selection.paramType === '') {
            this.selection.paramType = 'part';
        }
        this.getParamPartsSupplieSearch();
    }
    clearTextSearch() {
        this.selection.textSearch = '';
        // this.verifOKtoSearch();
    }
    verifOKtoSearch() {
        this.okToSearch = false;
        if (this.selection.paramType === 'service') {
            this.okToSearch = true;
            return;
        }
        let iPoint = 0;
        if (this.selection.brandName !== '') {
            iPoint++;
        }
        if (this.selection.brandRef !== '' && this.selection.brandRef.length >= 4) {
            iPoint++;
        }
        if (iPoint > 1) {
            this.okToSearch = true;
            return;
        }
        if (this.selection.brandRef !== '' && this.selection.brandRef.length >= 4) {
            this.okToSearch = true;
        }
    }
    searchList() {
        // console.log('OK to search');
        this.getParamPartsSuppliesSelect();
    }
    displayMessageBox(_titleBox, _messageBox, _messageType, _typeDialog, _actionCur, dataCur) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            id: 1,
            title: _titleBox,
            typeDialog: _typeDialog,
            panelClass: 'stdTheme',
            contentMessage: _messageBox,
            data1: '',
            data2: '',
            messageType: _messageType
        };
        const dialogRef = this._dialog.open(ModalCommonComponent, dialogConfig);
        dialogRef.afterClosed()
            .pipe(takeUntil(this.onDestroy))
            .subscribe(data => {
            // console.log('Dialog output:', data);
            if ((data === 'okAction') && (_actionCur === 'deleteParamSupplies')) {
                this.deleteParamSuppliesOK(dataCur);
            }
        });
    }
    onGridReady(params) {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        // params.api.sizeColumnsToFit();
    }
    onRowClicked(e) {
        if (e.event.target !== undefined) {
            const selectedRow = this.gridApi.getSelectedRows();
            const data = e.data;
            if ((!data) || (data === 'undefined')) {
                return;
            }
            const actionGrid = e.event.target.getAttribute('data-action-type');
            switch (actionGrid) {
                case 'edit': {
                    this.editPartSupplie(data);
                    break;
                }
                case 'trash': {
                    this.deletePartSupplies(data);
                    break;
                }
            }
        }
    }
    onSelectionChanged() {
        const selectedRow = this.gridApi.getSelectedRows();
        // console.log('Row selected : ' + selectedRow );
    }
    translateLabelsData(_dataArray) {
        if (!_dataArray[0]) {
            return null;
        }
        // ParamWorksRatesModel[]
        // langLabels?: ParamLabelsI18n[];
        const paramPartsSuppliesModel = [];
        for (const rowCur of _dataArray) {
            rowCur.paramTypeLabel = this._translate.instant(rowCur.paramType);
            const langLabels = rowCur.langLabels;
            if (langLabels === null) {
                continue;
            }
            for (const langLabel of langLabels) {
                if (langLabel.labelLang === this._translate.getCurrentLang()) {
                    rowCur.partsSuppliesLabel = langLabel.labelText;
                    break;
                }
            }
            paramPartsSuppliesModel.push(rowCur);
        }
        return paramPartsSuppliesModel;
    }
    extractColumnsName(_dataArray) {
        if (!_dataArray[0]) {
            return null;
        }
        // init update and save mark
        this.doUpdateDoc = [...Array(_dataArray.length)].map(x => false);
        this.dataColumnsName = Object.keys(_dataArray[0]);
        this.dataColumns = CommonMethods.optionsSelected(this._translate, this.dataColumnsDef, this.dataColumnsName, this.displayedColumns, false);
        // console.log('Columns current : ', this.dataColumns);
    }
    affectData(dataArray) {
        for (const itemCur of dataArray) {
            itemCur.paramMaj = moment(itemCur.stdLastupdate).format(environment.fmtDateTimeTZ);
            let paramOtherData;
            try {
                paramOtherData = JSON.parse(itemCur.otherData);
            }
            catch (error) {
                paramOtherData = this.otherDataEmpty();
            }
            finally { }
            try {
                itemCur.oldRef = paramOtherData.oldRef;
            }
            catch (error) {
                itemCur.oldRef = undefined;
            }
            finally { }
            try {
                itemCur.newRef = paramOtherData.newRef;
            }
            catch (error) {
                itemCur.newRef = undefined;
            }
            finally { }
        }
    }
    /*
    affectData(dataArray: any[]): Observable<any[]> {
      for (const itemCur of dataArray)  {
        itemCur.paramMaj = moment(itemCur.stdLastupdate).format(environment.fmtDateTimeTZ);
        let paramOtherData;
        try {
          paramOtherData = JSON.parse(itemCur.otherData) as ParamOtherData;
        } catch (error) {
          paramOtherData = this.otherDataEmpty();
        } finally { }
        try {
          itemCur.oldRef = paramOtherData.oldRef;
        } catch (error) {
          itemCur.oldRef = undefined;
        } finally { }
        try {
          itemCur.newRef = paramOtherData.newRef;
        } catch (error) {
          itemCur.newRef = undefined;
        } finally { }
      }
    
      return from(dataArray).pipe(
  
        concatMap((row, index) =>
          this.readStockByRef(row.brandRef).pipe(
            tap((productStock: ProductStock) => {
              if (productStock) {
                dataArray[index].paramQty = productStock.virtualStock;
                dataArray[index].stockId = productStock.stockId;
                dataArray[index].stockPrice = productStock.stockPrice;
                dataArray[index].stockPmp = productStock.stockPmp;
              }
            })
          )
        ),
        toArray(),
        map(() => dataArray)
      );
    
    }
      */
    displayStock() {
        return __awaiter(this, void 0, void 0, function* () {
            // this.OKtoDisplayList = false;
            // this.loadingIndicator = true;
            this.stockInProgress = true;
            const dataArray = this.dataSource.data;
            this.readStock(dataArray).subscribe((resultArray) => {
                this.dataSource.data = resultArray;
                this.gridApi.refreshCells({
                    force: true
                });
                this.stockInProgress = false;
                // this.OKtoDisplayList = true;
                // this.loadingIndicator = false;
            });
        });
    }
    readStock(dataArray) {
        const requests = dataArray.map((row, index) => this.readStockByRef(row.brandRef).pipe(map((productStock) => {
            if (productStock) {
                dataArray[index].paramQty = Number.isNaN(productStock.virtualStock) ? 0 : productStock.virtualStock;
                dataArray[index].stockId = productStock.stockId;
                dataArray[index].stockPrice = Number.isNaN(productStock.stockPrice) ? 0 : productStock.stockPrice;
                dataArray[index].stockPmp = Number.isNaN(productStock.stockPmp) ? 0 : productStock.stockPmp;
            }
            return dataArray[index];
        })));
        return forkJoin(requests).pipe(map(() => dataArray));
    }
    /*
    readStock(dataArray: any[]): Observable<any[]> {
  
      return from(dataArray).pipe(
        concatMap((row, index) =>
          this.readStockByRef(row.brandRef).pipe(
            tap((productStock: ProductStock) => {
              if (productStock) {
                dataArray[index].paramQty = productStock.virtualStock;
                dataArray[index].stockId = productStock.stockId;
                dataArray[index].stockPrice = productStock.stockPrice;
                dataArray[index].stockPmp = productStock.stockPmp;
              }
            })
          )
        ),
        last(),
        map(() => dataArray)
      );
  
    }
      */
    otherDataEmpty() {
        return {
            stockRefExists: false,
            accountingBuy: '',
            accountingSale: '',
            oldRef: '',
            newRef: '',
            barcodeType: '',
            externalId: ''
        };
    }
    // ---------------------------------------------------------------
    readStockByRef(brandRef) {
        const apiService = 'stockByRef';
        const apiName = 'stockManagement';
        const toolArgs = {
            toolDatas: []
        };
        toolArgs.toolDatas.push({
            key: 'toolCustomerNwsCode',
            value: this._apiService.getApiStockManagement().toolCustomerNwsCode
        });
        toolArgs.toolDatas.push({
            key: 'toolCustomerNwsId',
            value: this._apiService.getApiStockManagement().toolCustomerNwsId
        });
        toolArgs.toolDatas.push({
            key: 'brandRef',
            value: brandRef,
            listValues: undefined,
            arrayValues: undefined
        });
        return this._apiService.requestApis(this._userService.getUserLogged().entity, apiName, apiService, toolArgs).pipe(map((data) => {
            const toolApiResponse = data.body;
            if (toolApiResponse.statut === 'KO') {
                const itemResponse = toolApiResponse.toolDatas[0];
                if (itemResponse.value === '404') {
                    return null; // ou throwError(...) si tu préfères
                }
                return null;
            }
            return this.affectResponseStockByRef(toolApiResponse);
        }));
    }
    affectResponseStockByRef(toolApiResponse) {
        const productStock = {
            virtualStock: 0,
            stockId: '',
            stockPrice: 0,
            stockPmp: 0
        };
        for (const itemCur of toolApiResponse.toolDatas) {
            if (itemCur.key === 'nws_stock_qty') {
                productStock.virtualStock = parseFloat(itemCur.value);
            }
            if (itemCur.key === 'nws_stock_price') {
                productStock.stockPrice = parseFloat(itemCur.value);
            }
            if (itemCur.key === 'nws_stock_pmp') {
                productStock.stockPmp = parseFloat(itemCur.value);
            }
            if (itemCur.key === 'nws_stock_id') {
                productStock.stockId = itemCur.value;
            }
        }
        return productStock;
    }
    // ---------------------------------------------------------------
    toggleSidenav(_arg) {
        if (_arg === 'backdrop') {
            return;
        }
        this.isRegisterPartSupplie = false;
        if (this.displayType === 'newsearch') {
            return;
        }
        if (_arg === 'registerPartSupplie') {
            this.isRegisterPartSupplie = true;
        }
        // updateLinkBarcodeRef
        if (_arg === 'updateLinkBarcodeRef') {
            this.doCreatePartSupplie = false;
            this.doUpdateRatesPartSupplie = false;
            this.isRegisterPartSupplie = false;
            this.isUploadPartsSupplies = false;
            this.doUpdateLinkBarcodeRef = true;
            this.randomIdString = CommonMethods.randomString(5) + ' ' + Math.floor(Math.random() * 10000).toString();
        }
        // uploadPartsSupplies
        if (_arg === 'uploadPartsSupplies') {
            this.doCreatePartSupplie = false;
            this.doUpdateRatesPartSupplie = false;
            this.isRegisterPartSupplie = false;
            this.isUploadPartsSupplies = true;
            this.doUpdateLinkBarcodeRef = false;
            this.randomIdString = CommonMethods.randomString(5) + ' ' + Math.floor(Math.random() * 10000).toString();
        }
        if (_arg === 'displayStockMovements') {
            this.doCreatePartSupplie = false;
            this.doUpdateRatesPartSupplie = false;
            this.isRegisterPartSupplie = false;
            this.isUploadPartsSupplies = false;
            this.doDisplayStockMovements = true;
            this.doUpdateLinkBarcodeRef = false;
            this.randomIdString = CommonMethods.randomString(5) + ' ' + Math.floor(Math.random() * 10000).toString();
        }
        this.sidenavCollapsed = !this.sidenavCollapsed;
        if (this.sidenavCollapsed) {
            try {
                this.m_sidenav.close();
            }
            catch (error) {
            }
            finally { }
        }
        else {
            try {
                this.m_sidenav.open();
            }
            catch (error) {
            }
            finally { }
        }
    }
    updateLinkBarcodeRef() {
        this.doCreatePartSupplie = false;
        this.doUpdateRatesPartSupplie = false;
        this.isRegisterPartSupplie = false;
        this.isUploadPartsSupplies = false;
        this.doUpdateLinkBarcodeRef = true;
        this.toggleSidenav('updateRatesPartSupplie');
    }
    updateRatesPartSupplie() {
        this.isUploadPartsSupplies = false;
        this.doCreatePartSupplie = false;
        this.doUpdateRatesPartSupplie = true;
        this.toggleSidenav('updateRatesPartSupplie');
    }
    displayStockMovements() {
        this.isUploadPartsSupplies = false;
        this.doCreatePartSupplie = false;
        this.doUpdateRatesPartSupplie = false;
        this.doDisplayStockMovements = true;
        this.toggleSidenav('displayStockMovements');
    }
    editPartSupplie(row) {
        this.partSupplieToUpdate = row;
        this.actionType = 'update';
        this.isUploadPartsSupplies = false;
        this.doCreatePartSupplie = false;
        this.doUpdateRatesPartSupplie = false;
        this.doDisplayStockMovements = false;
        this.toggleSidenav('registerPartSupplie');
    }
    addPartSupplie() {
        this.doCreatePartSupplie = true;
        this.isUploadPartsSupplies = false;
        this.actionType = 'add';
        this.partSupplieToUpdate = undefined;
        this.doUpdateRatesPartSupplie = false;
        this.toggleSidenav('registerPartSupplie');
    }
    uploadPartSupplie() {
        this.doCreatePartSupplie = false;
        this.isUploadPartsSupplies = true;
        this.actionType = 'upload';
        this.partSupplieToUpdate = undefined;
        this.toggleSidenav('uploadPartsSupplies');
    }
    translateLabelsColumns() {
        if (this.displayedColumns === undefined) {
            return;
        }
        const nbCol = this.displayedColumns.length;
        const localColumns = this.displayedColumns;
        this.displayedColumns = [];
        for (let i = 0; i < nbCol; i++) {
            const lTmp = localColumns[i];
            this.displayedColumns.push({
                'prop': lTmp.prop,
                'name': this._translate.getTranslate(lTmp.prop),
                'isDate': false
            });
        }
    }
    deletePartSupplies(row) {
        // console.log('deleteEntity Row clicked: ', row);
        let titleBox;
        let messageBox;
        titleBox = 'deleting part & supplie';
        titleBox = this._translate.getTranslate(titleBox);
        messageBox = row.partsSuppliesLabel;
        this.displayMessageBox(titleBox, messageBox, 'WARNING', 'confirmAction', 'deleteParamSupplies', row);
    }
    deleteParamSuppliesOK(row) {
        this._wksCentralService.saveParamPartSupplie(row, 'deleteParamSupplies')
            .subscribe(() => {
            this._wksCentralService.onRegisterValid.emit('deleteParamSupplies');
        }, () => {
        });
    }
}
